import React from 'react';

interface BrandLoaderProps {
    fullscreen?: boolean;
    caption?: string;
}

const BrandLoader = ({ fullscreen = true, caption = 'Loading' }: BrandLoaderProps) => {
    return (
        <div
            className={`np-loader${fullscreen ? ' np-loader--fullscreen' : ''}`}
            role="status"
            aria-live="polite"
            aria-label={caption}
        >
            <div className="np-loader__stage" aria-hidden="true">
                <span className="np-loader__ripple np-loader__ripple--a" />
                <span className="np-loader__ripple np-loader__ripple--b" />
                <div className="np-loader__orbit">
                    <span className="np-loader__coin" />
                    <span className="np-loader__coin" />
                    <span className="np-loader__coin" />
                </div>
                <div className="np-loader__core">
                    <svg
                        className="np-loader__mark"
                        viewBox="0 0 160 120"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <defs>
                            <linearGradient id="npBarFlow" x1="0%" y1="50%" x2="100%" y2="50%">
                                <stop offset="0%" stopColor="#6fbf82" />
                                <stop offset="40%" stopColor="#b6f0c0" />
                                <stop offset="70%" stopColor="#7cc58f" />
                                <stop offset="100%" stopColor="#9ee0ab" />
                            </linearGradient>
                            <filter id="npSoftGlow" x="-30%" y="-30%" width="160%" height="160%">
                                <feGaussianBlur stdDeviation="2.4" result="blur" />
                                <feMerge>
                                    <feMergeNode in="blur" />
                                    <feMergeNode in="SourceGraphic" />
                                </feMerge>
                            </filter>
                        </defs>
                        <rect
                            className="np-loader__ring np-loader__ring--ghost"
                            x="8"
                            y="8"
                            width="104"
                            height="104"
                            rx="32"
                            ry="32"
                            fill="none"
                            stroke="#004e64"
                            strokeWidth="12"
                        />
                        <g className="np-loader__bar-wrap">
                            <rect
                                className="np-loader__bar"
                                x="42"
                                y="36"
                                width="110"
                                height="48"
                                rx="16"
                                ry="16"
                                fill="url(#npBarFlow)"
                                filter="url(#npSoftGlow)"
                            />
                        </g>
                        <rect
                            className="np-loader__ring np-loader__ring--trace"
                            x="8"
                            y="8"
                            width="104"
                            height="104"
                            rx="32"
                            ry="32"
                            fill="none"
                            stroke="#004e64"
                            strokeWidth="12"
                            strokeLinecap="round"
                            pathLength="100"
                        />
                    </svg>
                </div>
            </div>
            <div className="np-loader__word" aria-hidden="true">
                {'nowpay'.split('').map((letter, index) => (
                    <span key={`${letter}-${index}`} style={{ animationDelay: `${index * 0.08}s` }}>
                        {letter}
                    </span>
                ))}
            </div>
            <span className="np-loader__caption">
                {caption}
                <span className="np-loader__dots">
                    <i /><i /><i />
                </span>
            </span>
        </div>
    );
};

export default BrandLoader;
